import { IndicationType } from '../indication-type.enum';

export enum TreatmentApplianceType {
    Unset = 0,
    StudyModelSmileDesign = 1,
    AlignerRetainerModel = 2,
    RemovableDieModel = 3,
    ModelCustomBleachingTray = 4,
    OcclusalGuard = 5,
    SurgicalGuide = 6,
    TryInDenture = 7,
    DentureBase = 8,
    HybridDenture = 9,
    DentureTeeth = 10,
    Crown = 11,
    Castable = 12,
    GingivaMask = 13,
    InlayAndOnlay = 14,
    IndirectBondingTray = 15,
    CustomImpressionTray = 16,
    Bridge = 17,
    SmileDesignSnapOn = 18,
    Veneer = 19,
    ImplantCrown = 20,
    Retainer = 21,
    AnteriorCrown = 22,
    Scan = 24,
    Restorations = 25,
}

export function mapApplianceTypeToIndicationType(applianceTypeId: TreatmentApplianceType): IndicationType {
    switch (applianceTypeId) {
        case TreatmentApplianceType.Unset:
            return IndicationType.Unset;
        case TreatmentApplianceType.StudyModelSmileDesign:
            return IndicationType.StudyModelSmileDesign;
        case TreatmentApplianceType.AlignerRetainerModel:
            return IndicationType.AlignerRetainerModel;
        case TreatmentApplianceType.RemovableDieModel:
            return IndicationType.RemovableDieModel;
        case TreatmentApplianceType.ModelCustomBleachingTray:
            return IndicationType.ModelCustomBleachingTray;
        case TreatmentApplianceType.OcclusalGuard:
            return IndicationType.OcclusalGuard;
        case TreatmentApplianceType.SurgicalGuide:
            return IndicationType.SurgicalGuide;
        case TreatmentApplianceType.TryInDenture:
            return IndicationType.TryInDenture;
        case TreatmentApplianceType.DentureBase:
            return IndicationType.DentureBase;
        case TreatmentApplianceType.HybridDenture:
            return IndicationType.HybridDenture;
        case TreatmentApplianceType.DentureTeeth:
            return IndicationType.DentureTeeth;
        case TreatmentApplianceType.Crown:
            return IndicationType.Crown;
        case TreatmentApplianceType.Castable:
            return IndicationType.Castable;
        case TreatmentApplianceType.GingivaMask:
            return IndicationType.GingivaMask;
        case TreatmentApplianceType.InlayAndOnlay:
            return IndicationType.InlayAndOnlay;
        case TreatmentApplianceType.IndirectBondingTray:
            return IndicationType.IndirectBondingTray;
        case TreatmentApplianceType.CustomImpressionTray:
            return IndicationType.CustomImpressionTray;
        case TreatmentApplianceType.Bridge:
            return IndicationType.Bridge;
        case TreatmentApplianceType.SmileDesignSnapOn:
            return IndicationType.SmileDesignSnapOn;
        case TreatmentApplianceType.Veneer:
            return IndicationType.Veneer;
        case TreatmentApplianceType.ImplantCrown:
            return IndicationType.ImplantCrown;
        case TreatmentApplianceType.Retainer:
            return IndicationType.Retainer;
        case TreatmentApplianceType.Restorations:
            return IndicationType.Restorations;
        default:
            return IndicationType.Unset;
    }
}
